import React, { useState, useEffect, useCallback } from 'react'
import { makeStyles, withStyles } from '@material-ui/styles'
import { CardContent, Grid, Button, CircularProgress } from '@material-ui/core'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import PhotoCamera from '@material-ui/icons/PhotoCamera'
import Close from '@material-ui/icons/Close'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import red from '@material-ui/core/colors/red'
import { useFetch } from 'hooks/useFetch'
import Webcam from 'react-webcam'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import useRouter from 'utils/useRouter'
import { useDispatch } from 'react-redux'
import { uniqueId } from 'lodash'
import { useSnackBar } from 'hooks/useSnackBar'

const useStyles = makeStyles((theme) => ({
  root: {},
  alert: {
    marginBottom: theme.spacing(3),
  },
  margin: {
    margin: theme.spacing(1),
  },
  formGroup: {
    marginBottom: theme.spacing(3),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  fieldHint: {
    margin: theme.spacing(1, 0),
  },
  tags: {
    marginTop: theme.spacing(1),
    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
  },
  flexGrow: {
    flexGrow: 1,
  },
  dateField: {
    '& + &': {
      marginLeft: theme.spacing(2),
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  enviarImagemComputador: {
    display: 'none',
  },
  fotos: {
    margin: theme.spacing(1),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}))

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: 'user',
}

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[400],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
}))(Button)

export const InserirImagem = (props) => {
  const { rotaRaiz, setFormState, rotaRetornofront, tipoUpload, rotaUpload, formState, setProcessando, processando } = props
  const classes = useStyles()
  const snackBar = useSnackBar()
  const fetch = useFetch()
  const webcamRef = React.useRef(null)
  const [fotosInseridas, setFotosInseridas] = useState([])
  const [imageData, setImageData] = useState(null)
  const handleCapturarFoto = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot()
    setImageData(imageSrc)
  }, [webcamRef])
  const dispatch = useDispatch()
  const router = useRouter()
  const handleResetFoto = useCallback(() => {
    setImageData(null)
  }, [])
  const [alertaErroTipoImagem, setAlertaErroTipoImagem] = useState(false)
  const [deletar, setDeletar] = useState(false)
  const [FotoIdDeletar, setFotoIdDeletar] = useState()
  const [open, setOpen] = React.useState(false)

  const fetchFoto = useCallback(
    async (id) => {
      try {
        setProcessando(true)
        const response = await fetch.get(`${rotaRaiz}/${id}`)
        fotosInseridas.push({ data: response.data.arquivo.data, id })
        setFotosInseridas(fotosInseridas)
        setFormState((formState) => ({
          ...formState,
        }))
        setProcessando(false)
      } catch (error) {
        console.log(error) //eslint-disable-line
      }
    },
    [dispatch, fotosInseridas, props, router]
  )

  const getBase64 = (file, cb) => {
    const reader = new FileReader()

    reader.readAsDataURL(file)
    reader.onload = function e() {
      cb(reader.result, file.name || 'upload')
    }
    reader.onerror = function ee() {
      // ignore
    }
  }

  function dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1])

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i += 1) {
      ia[i] = byteString.charCodeAt(i)
    }

    // write the ArrayBuffer to a blob, and you're done
    const bb = new Blob([ab], { type: mimeString })
    return bb
  }

  const handleEnviarImagemComputador = (event) => {
    getBase64(event.target.files[0], async (result, filename) => {
      try {
        if (setProcessando) setProcessando(true)

        const formData = new FormData()
        const blob = dataURItoBlob(result)
        formData.append(tipoUpload, blob, filename)
        const response = await fetch.postOpen(rotaUpload, formData)

        formState.values.fotos.push(response.data.arquivo)
        await fetchFoto(response.data.arquivo)
        if (setProcessando) setProcessando(false)
      } catch (error) {
        if (error.response.status === 415) {
          setAlertaErroTipoImagem(true)
          setTimeout(() => {
            setAlertaErroTipoImagem(false)
          }, 8000)
        }
      }
    })
  }

  const handleSalvarFoto = useCallback(async () => {
    try {
      const formData = new FormData()
      const blob = dataURItoBlob(imageData)
      formData.append(tipoUpload, blob, 'webcam')
      const response = fetch.postOpen(rotaUpload, formData)
      formState.values.fotos.push(response.data.arquivo)
      setOpen(false)
      setImageData(null)
      fetchFoto(response.data.arquivo)
    } catch (error) {
      if (error.response.status === 415) {
        setAlertaErroTipoImagem(true)
        setTimeout(() => {
          setAlertaErroTipoImagem(false)
        }, 8000)
      }
    }
  }, [fetchFoto, imageData, formState.values.fotos, rotaUpload, tipoUpload])

  const deletarFechar = () => {
    setDeletar(false)
  }

  const handleDeletarfoto = useCallback(async () => {
    if (setProcessando) setProcessando(true)
    await fetch.del(`${rotaRaiz}/${FotoIdDeletar}/deletar`)
    const index = formState.values.fotos.indexOf(FotoIdDeletar)
    formState.values.fotos.splice(index, 1)
    fotosInseridas.splice(index, 1)
    deletarFechar()
    if (setProcessando) setProcessando(false)
  }, [FotoIdDeletar, dispatch, fotosInseridas, formState.values.fotos, rotaRaiz, rotaRetornofront, router])

  useEffect(() => {
    for (let i = 0; i < formState.values.fotos.length; i += 1) {
      fetchFoto(formState.values.fotos[i])
    }
  }, [formState.values.fotos])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const deletarAbrir = (event, FotoId) => {
    setFotoIdDeletar(FotoId)
    setDeletar(true)
  }

  const arrayBufferToBase64 = (buffer) => {
    let binary = ''
    const bytes = [].slice.call(new Uint8Array(buffer))
    // eslint-disable-next-line no-return-assign
    bytes.forEach((b) => (binary += String.fromCharCode(b)))
    return window.btoa(binary)
  }

  const getSrc = (data) => {
    const b64 = arrayBufferToBase64(data)
    const foto = `data:image/jpeg;base64,${b64}`
    return foto
  }

  return (
    <CardContent>
      {formState.values.fotos.length > 0 && fotosInseridas.length === 0 ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid alignItems="center" container justify="flex-start">
          {fotosInseridas.map((fotoVestigio) => (
            <Grid key={uniqueId()} className={classes.fotos} item md={5} sm={5} xs={12}>
              <img src={getSrc(fotoVestigio.data)} width="100%" spacing={2} alt="" />
              <Button key={uniqueId()} variant="outlined" color="primary" size="small" className={(classes.button, classes.margin)} onClick={(e) => deletarAbrir(e, fotoVestigio.id)} endIcon={<Close />}>
                Remover
              </Button>
            </Grid>
          ))}
        </Grid>
      )}

      <Grid className={classes.alert} item md={12} sm={12} xs={12}>
        {alertaErroTipoImagem &&
          snackBar({
            variant: 'error',
            message: 'Tipo de arquivo não suportado. Selecione um arquivo .jpg',
          })}
      </Grid>
      <Grid className={classes.item} item md={12} sm={12} xs={12}>
        <Grid className={classes.fieldGroup} item md={5} sm={8} xs={12}>
          <Button color="primary" variant="outlined" startIcon={<PhotoCamera />} onClick={handleOpen}>
            Usar Câmera
          </Button>
          <input accept="image/*, .jpg, .jpeg, .png, .JPG, .JPEG, .PNG, .heic, .HEIC" className={classes.enviarImagemComputador} id="enviarImagemComputador" name="fotosVestigio" type="file" onChange={handleEnviarImagemComputador} />
          <label htmlFor="enviarImagemComputador">
            <Button color="primary" variant="outlined" component="span" startIcon={<CloudUploadIcon />}>
              Do computador
            </Button>
          </label>
        </Grid>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              {imageData ? (
                <div>
                  <div>
                    <img src={imageData} width="100%" alt="" />
                  </div>
                  <div className={classes.fieldGroup}>
                    <Button color="primary" variant="outlined" onClick={handleSalvarFoto}>
                      Salvar foto
                    </Button>
                    <Button
                      // color="secondary"
                      variant="outlined"
                      onClick={handleResetFoto}
                    >
                      Refazer foto
                    </Button>
                    <ColorButton onClick={handleClose}>Fechar</ColorButton>
                  </div>
                </div>
              ) : (
                <div>
                  <div>
                    <Webcam audio={false} height="100%" width="100%" minScreenshotWidth={1920} minScreenshotHeight={1080} ref={webcamRef} screenshotFormat="image/jpeg" videoConstraints={videoConstraints} />
                  </div>

                  <div>
                    <Button color="primary" variant="outlined" onClick={handleCapturarFoto}>
                      Capturar foto
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Fade>
        </Modal>
      </Grid>
      <Dialog open={deletar} onClose={deletarFechar} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogContent>
          <DialogContentText id="alert-dialog-description">Tem certeza que deseja remover a imagem?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={deletarFechar} color="primary">
            Não
          </Button>
          <ColorButton disabled={processando} onClick={handleDeletarfoto} variant="outlined" color="secondary" autoFocus>
            Sim
            {processando && <CircularProgress size={24} className={classes.buttonProgress} />}
          </ColorButton>
        </DialogActions>
      </Dialog>
    </CardContent>
  )
}
